export const getDerivedOutputMetadata = () => {
    return {
        income: {},
        incomeType: {},
        annualIncome: {},
        hourlyIncome: {},
        payCycle: {},
        employmentStatus: {},
        minimumMonthsOfEmployment: {},
        nextExpectedPayDate: {}
    };
};
//# sourceMappingURL=get-derived-outputs-metadata.js.map